<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">인재상</h3>
      </div>
      <div class="txt">
        <h4 class="fs-50 fMTP-EB main_color pdb30">IDEAL EMPLOYEE</h4>
        <p class="lh30">동국제강그룹은 DK WAY를 바탕으로 세계에서 통하는 ‘최고 경쟁력의 DK Performer’로 성장할 수 있도록 동국인들의 변화와 열정을 응원합니다.</p>
        
        <p class="pdt50 pdb50">
          <img :src="require('./../../assets/img/sub/04/0401_01.png')" />
        </p>

        <h4 class="fs-50 pdt50 fMTP-EB main_color">WORK PRINCIPLE</h4>
        
        <ul class="workprincple">
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0401_02.png')" />
              </dd> 
              <dt>소통 : Communication</dt> 
              <dd>어떤 아이디어든 거리낌 없이 얘기할 수 있는 분위기를 조성하고, 상대방의 의견을 경청한다.</dd>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0401_03.png')" />
              </dd> 
              <dt>몰입 : Engagement</dt> 
              <dd>조직의 목표 및 개인별 역할을 명확히 이해하며, 이를 성공적으로 완수하기 위해 집중한다.</dd>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0401_04.png')" />
              </dd> 
              <dt>협력 : Cooperation</dt> 
              <dd>시너지 효과 창출을 위하여 존중과 배려를 바탕으로 이해관계자와 협조한다.</dd>
            </dl>
          </li>
        </ul>
        <ul class="workprincple">
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0401_05.png')" />
              </dd> 
              <dt>열정 : Passion</dt> 
              <dd>목표 달성 및 문제 해결에 대한 강한 집념으로 포기하지 않고 끝까지 노력한다.</dd>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0401_06.png')" />
              </dd> 
              <dt>변화 : Change</dt> 
              <dd>새로운 시도와 전문가가 되기 위한 배움을 멈추지 않는다.</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Talent.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub04/Talent.vue